import { useEffect, useState } from 'react'

import { useEventListener } from './useEventListener'

export const useOnKeysDown = (
  targetKeys: string[],
  callback?: (keyWasPressed: boolean) => void,
) => {
  const [keysPressed, setKeysPressed] = useState<Record<string, boolean>>({})

  useEffect(() => {
    const allKeysPressed = targetKeys.every(key => keysPressed[key])
    if (callback) callback(allKeysPressed)
  }, [callback, keysPressed, targetKeys])

  const downHandler = ({ key }: KeyboardEvent) => {
    if (targetKeys.includes(key)) {
      setKeysPressed(prev => ({ ...prev, [key]: true }))
    }
  }

  const upHandler = ({ key }: KeyboardEvent) => {
    if (targetKeys.includes(key)) {
      setKeysPressed(prev => ({ ...prev, [key]: false }))
    }
  }

  useEventListener('keydown', downHandler)
  useEventListener('keyup', upHandler)

  return targetKeys.every(key => keysPressed[key])
}
